/** Spanish operational catalog, matching the existing OrderTaker locale. */
export const stockMessages = {
  unknown: 'No se pudo confirmar el envío. El carrito se conserva; reintenta la misma solicitud.',
  policy: 'No se pudo verificar el control de stock. El carrito se conserva.',
  receiptUnknown: 'El pedido fue enviado, pero no se pudo confirmar la cuenta. Revisa la mesa antes de reintentar el cobro.',
  shortage: 'Stock insuficiente. No se envió el pedido y el carrito se conserva.',
  stockLoading: 'Consultando disponibilidad orientativa…',
  stockError: 'Disponibilidad desconocida. El servidor verificará todo el pedido al enviar.',
  stockFresh: 'Disponibilidad orientativa consultada recientemente. Se verificará nuevamente al enviar.',
  stockStale: 'La disponibilidad puede haber cambiado. Se verificará nuevamente al enviar.',
  refresh: 'Actualizar disponibilidad',
  selections: 'Selecciones afectadas',
  ingredient: 'Ingrediente',
  missing: 'Cantidad faltante',
  unit: 'Unidad',
} as const;
